module.exports = __webpack_public_path__ + "static/img/bindin.6051bc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bindin.png
// module id = OEbk
// module chunks = 174